import React from 'react';
import styled from 'astroturf/react';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;

  i {
    font-size: 25px;
  }
`;

const VideoUnavailable: React.FunctionComponent = () => (
  <Container>
    <i className="fa fa-spinner fa-spin" />
    <h3>Video Processing in Progress</h3>
  </Container>
);

export default VideoUnavailable;
